import { RepositoryFactory } from "../../api/RepositoryFactory";
import { cloneDeep } from "lodash-es";
const Formula = RepositoryFactory.get("formulas");

export const formulas = {
  namespaced: true,
  state: {
    formulas: [],
    formulaTemplates: [],
    constants: [],
  },

  actions: {
    async getFormulas({ commit }) {
      await Formula.getFormulas()
        .then((x) => {
          x.data.forEach((element) => {
            element["output"] =
              element.outputDeveui + " - " + element.outputKey;
          });
          commit("SET_FORMULAS", x.data);
        })
        .catch((e) => {
          commit("SET_FORMULAS", []);
          console.error("Error fetching the formulas for company", e);
        });
    },

    async getFormulasByConstant(_, id) {
      return await Formula.getFormulasByConstant(id)
        .then((x) => {
          x.data.forEach((element) => {
            element["output"] =
              element.outputDeveui + " - " + element.outputKey;
          });
          return x.data;
        })
        .catch((e) => {
          console.error(`Error fetching the formulas for constant ${id}`, e);
          return undefined;
        });
    },

    async getFormulasByTag(_, deveui) {
      return await Formula.getFormulasByTag(deveui)
        .then((x) => {
          x.data.forEach((element) => {
            element["output"] =
              element.outputDeveui + " - " + element.outputKey;
          });
          return x.data;
        })
        .catch((e) => {
          console.error(`Error fetching the formulas for node ${deveui}`, e);
          return undefined;
        });
    },

    async getFormulasByTagKey(_, { deveui, key }) {
      return await Formula.getFormulasByTagKey(deveui, key)
        .then((x) => {
          x.data.forEach((element) => {
            element["output"] =
              element.outputDeveui + " - " + element.outputKey;
          });
          return x.data;
        })
        .catch((e) => {
          console.error(
            `Error fetching the formulas for sensor ${key} on node ${deveui}`,
            e
          );
          return undefined;
        });
    },

    async createOrUpdateFormula(_, payload) {
      return await Formula.createOrUpdateFormula(payload)
        .then(() => true)
        .catch((e) => {
          console.error("Error creating/updating the formula", e);
          return false;
        });
    },

    async createFormulaUsingImport(_, payload) {
      return await Formula.createFormulaUsingImport(payload)
        .then(() => true)
        .catch((e) => {
          console.error("Error creating the formula with template", e);
          return false;
        });
    },

    async deleteFormula(_, id) {
      return await Formula.deleteFormula(id)
        .then(() => true)
        .catch((e) => {
          console.error("Error deleting the formula", e);
          return false;
        });
    },

    async getFormulaTemplates({ commit }) {
      await Formula.getFormulaTemplates()
        .then((x) => commit("SET_FORMULATEMPLATES", x.data))
        .catch((e) => {
          commit("SET_FORMULATEMPLATES", []);
          console.error("Error fetching the formula templates for company", e);
        });
    },

    async createOrUpdateFormulaTemplate(_, payload) {
      return await Formula.createOrUpdateFormulaTemplate(payload)
        .then(() => true)
        .catch((e) => {
          console.error("Error creating/updating the formula template", e);
          return false;
        });
    },

    async deleteFormulaTemplate(_, id) {
      return await Formula.deleteFormulaTemplate(id)
        .then(() => true)
        .catch((e) => {
          console.error("Error deleting the formula template", e);
          return false;
        });
    },

    async getConstants({ commit }) {
      await Formula.getConstants()
        .then((x) => commit("SET_CONSTANTS", x.data))
        .catch((e) => {
          commit("SET_CONSTANTS", []);
          console.error("Error fetching the constants for company", e);
        });
    },

    async createOrUpdateConstant(_, payload) {
      return await Formula.createOrUpdateConstant(payload)
        .then(() => true)
        .catch((e) => {
          console.error("Error creating/updating the constant", e);
          return false;
        });
    },

    async deleteConstant(_, id) {
      return await Formula.deleteConstant(id)
        .then(() => true)
        .catch((e) => {
          console.error("Error deleting the constant", e);
          return false;
        });
    },

    async deleteConstantForce(_, id) {
      return await Formula.deleteConstantForce(id)
        .then(() => true)
        .catch((e) => {
          console.error("Error deleting the constant", e);
          return false;
        });
    },

    async getVariablesFromFormulaString(_, formulaString) {
      return await Formula.getVariablesFromFormulaString({
        value: formulaString,
      })
        .then((x) => x.data)
        .catch((e) => {
          console.error(
            "Error trying to extract variables from the formula",
            e
          );
          return [];
        });
    },

    async testFormula(_, payload) {
      return await Formula.testFormula(payload)
        .then((x) => x.data)
        .catch((e) => {
          console.error("Error testing the formula", e);
          return {
            success: false,
            value: e,
          };
        });
    },
  },

  mutations: {
    SET_FORMULAS(state, payload) {
      state.formulas = payload;
    },

    SET_FORMULATEMPLATES(state, payload) {
      state.formulaTemplates = payload;
    },

    SET_CONSTANTS(state, payload) {
      state.constants = payload;
    },
  },

  getters: {
    getFormulaById: (state) => (id) => {
      return cloneDeep(state.formulas.find((d) => d.formulaId === id));
    },

    getFormulaTemplateById: (state) => (id) => {
      return cloneDeep(
        state.formulaTemplates.find((d) => d.formulaTemplateId === id)
      );
    },

    getConstantById: (state) => (id) => {
      return cloneDeep(state.constants.find((d) => d.constantId === id));
    },

    getFormulaTemplateByName: (state) => (name) => {
      return cloneDeep(state.formulaTemplates.find((x) => x.name === name));
    },

    getConstantByName: (state) => (name) => {
      return cloneDeep(state.constants.find((x) => x.name === name));
    },
  },
};
